import { render } from "./CopyText.vue?vue&type=template&id=d7a6e790&scoped=true&ts=true"
import script from "./CopyText.vue?vue&type=script&lang=ts"
export * from "./CopyText.vue?vue&type=script&lang=ts"

import "./CopyText.vue?vue&type=style&index=0&id=d7a6e790&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a6e790"]])

export default __exports__